<template>
  <div class="textbook-statistics">
    <div class="module-header">
      <h3 class="module-title" :class="{'clickable': currentRegion.level !== 'city'}" role="button" tabindex="0" @click="goOrderScreen" @keydown.enter="goOrderScreen">
        线上教材征订
      </h3>
      <!-- <div class="time-selector">
        <button 
          v-for="option in timeOptions" 
          :key="option.value"
          :class="['time-btn', { active: textbookStatistics.period === option.value }]"
          @click="changePeriod(option.value)"
        >
          {{ option.label }}
        </button>
      </div> -->
    </div>
    <div class="statistics-content">
      <div class="stats-grid">
        <!-- 总订单数 -->
        <div class="stat-card" :class="[{ 'float-on': shouldFloat }, 'float-small']">
          <div class="stat-info">
            <div class="stat-value">{{ formatOrderNumber(textbookStatistics.totalOrders) }}</div>
            <div class="stat-label">{{ textbookStatistics.autumnAmountLabel || '本期' }}总订单数{{ getOrderUnit(textbookStatistics.totalOrders) }}</div>
          </div>
          <div class="pyramid-graphic"></div>
        </div>
        <!-- 25秋总码洋（万） -->
        <div class="stat-card" :class="[{ 'float-on': shouldFloat }, 'float-large']">
          <div class="stat-info">
            <div class="stat-value">{{ formatWanNoSuffix(textbookStatistics.autumnAmount25) }}</div>
            <div class="stat-label">{{ textbookStatistics.autumnAmountLabel || '本期' }}总码洋(万)</div>
            <div class="stat-tb">同比 {{ textbookStatistics.autumnAmount25Tb }}%</div>
          </div>
          <div class="pyramid-graphic"></div>
        </div>
        <!-- 2025年总码洋（万） -->
        <div class="stat-card" :class="[{ 'float-on': shouldFloat }, 'float-small']">
          <div class="stat-info">
            <div class="stat-value">{{ formatWanNoSuffix(textbookStatistics.totalAmount2025) }}</div>
            <div class="stat-label">{{ textbookStatistics.totalAmountLabel || '年度' }}总码洋(万)</div>
            <div class="stat-tb">同比 {{ textbookStatistics.totalAmount2025Tb }}%</div>
          </div>
          <div class="pyramid-graphic"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'TextbookStatistics',
  data() {
    return {
      timeOptions: [
        { label: '近7天', value: 'recent7days' },
        { label: '本月', value: 'month' },
        { label: '近半年', value: 'halfyear' },
        { label: '最新季次', value: 'quarter' }
      ]
    }
  },
  computed: {
    ...mapState('textbook', ['textbookStatistics']),
    ...mapState(['loading']),
    ...mapState('region', ['currentRegion']),
    shouldFloat() {
      const s = this.textbookStatistics || {}
      const hasData = (
        (s.totalOrders && s.totalOrders > 0) ||
        (s.totalAmount2025 && s.totalAmount2025 > 0) ||
        (s.autumnAmount25 && s.autumnAmount25 > 0)
      )
      return !this.loading && hasData
    }
  },
  mounted() {
  },
  methods: {
    ...mapActions('textbook', ['fetchTextbookStatistics']),
    goOrderScreen() {
      if (this.$route && this.$route.name === 'OrderScreen') return
      if (this.currentRegion.level == 'city') return
      this.$router.push({ name: 'OrderScreen' })
    },
    formatPlainNumber(num) {
      const n = parseInt(num) || 0
      return n
    },
    formatOrderNumber(num) {
      const n = parseInt(num) || 0
      if (n >= 10000) {
        const wan = (n / 10000).toFixed(1)
        // 如果小数部分为0，则显示整数
        return parseFloat(wan) % 1 === 0 ? parseInt(wan) : wan
      } else {
        return n
      }
    },
    getOrderUnit(num) {
      const n = parseInt(num) || 0
      return n >= 10000 ? '(万笔)' : '(笔)'
    },
    formatWanNoSuffix(amount) {
      const num = parseFloat(amount) || 0
      return Math.round(num / 10000)
    },
    async changePeriod(period) {
      if (period !== this.textbookStatistics.period) {
        try {
          await this.fetchTextbookStatistics(period)
        } catch (error) {
          console.error('Failed to fetch textbook statistics:', error)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.textbook-statistics {
  height: 100%;
  display: flex;
  flex-direction: column;

  .module-title.clickable {
    cursor: pointer;
    user-select: none;
  }

  .statistics-content {
    flex: 1;
    min-height: 186px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 10px 0 20px;

    .stats-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);

      .stat-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;
        padding: 16px 0;
        transition: all 0.3s ease;
        position: relative;
        /* 性能优化：提前声明将发生的变化，避免合成层抖动 */
        will-change: transform;
        backface-visibility: hidden;
        transform: translateZ(0);

        /* 浮动动画：统一频率 3.6s，加载完成时触发；仅向下沉，到达底部回到原位 */
        &.float-on.float-small {
          animation: float-updown-small 3.6s cubic-bezier(0.4, 0, 0.2, 1) infinite both;
        }
        &.float-on.float-large {
          animation: float-updown-large 3.6s cubic-bezier(0.4, 0, 0.2, 1) infinite both;
        }

        .stat-info {
          width: 100%;
          height: 100%;
          text-align: center;
          line-height: 1;
          position: absolute;
          top: 2px;
          display: flex;
          flex-direction: column;

          .stat-value {
            font-size: 21px;
            font-weight: bold;
            color: #ffffff;
            margin-bottom: 14px;
          }

          .stat-label {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.85);
          }

          .stat-tb {
            font-size: 12px;
            margin-top: auto;
          }
        }

        .pyramid-graphic {
          width: 106px;
          height: 107px;
          background: url("@/assets/images/zd_img.png") no-repeat center center;
          background-size: 100% auto;
        }
      }
    }
  }
}
@keyframes float-updown-small {
  0%   { transform: translateY(0); }
  50%  { transform: translateY(16px); }
  100% { transform: translateY(0); }
}

@keyframes float-updown-large {
  0%   { transform: translateY(0); }
  50%  { transform: translateY(24px); }
  100% { transform: translateY(0); }
}
</style>